// Ponto único de leitura/escrita para dados persistidos do side menu
// (balão do consultor, popups, etc.). Dois níveis de duração, cada um no
// mecanismo nativo que já resolve o problema sozinho, sem timers manuais:
//
// - localStorage — sobrevive a fechar o navegador. Usado para coisas que
//   devem ficar "lembradas" entre visitas (ex.: o usuário fechou o balão
//   manualmente, então ele some por um tempo mesmo em sessões futuras).
// - sessionStorage — escopo de aba: persiste ao navegar/recarregar dentro
//   da mesma aba e zera sozinho quando a aba/janela é fechada. Usado para
//   contadores "por sessão" (ex.: quantas vezes o balão já piscou), porque
//   é exatamente essa a semântica de sessão que precisamos — sem precisar
//   inventar um timer de inatividade pra simular o mesmo resultado.
if (!window.ZrzsSideMenuStorage) {
  (function () {
    const LOCAL_KEY = 'zrzs-side-menu-state';
    const SESSION_KEY = 'zrzs-side-menu-session';

    /**
     * @param {Storage} storage
     * @param {string} key
     * @returns {Record<string, unknown>}
     */
    function safeRead(storage, key) {
      try {
        const raw = storage.getItem(key);
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    }

    /**
     * @param {Storage} storage
     * @param {string} key
     * @param {Record<string, unknown>} patch
     * @returns {void}
     */
    function safeWrite(storage, key, patch) {
      try {
        const current = safeRead(storage, key);
        storage.setItem(key, JSON.stringify({ ...current, ...patch }));
      } catch {
        // Storage indisponível (modo privado, cota excedida, etc.) — a
        // feature correspondente simplesmente não persiste, sem travar nada.
      }
    }

    window.ZrzsSideMenuStorage = {
      /**
       * @returns {number | null} timestamp (ms) do último fechamento manual do balão
       */
      getDismissedAt() {
        const value = safeRead(window.localStorage, LOCAL_KEY).dismissedAt;
        return typeof value === 'number' ? value : null;
      },
      /**
       * @param {number} timestamp
       * @returns {void}
       */
      setDismissedAt(timestamp) {
        safeWrite(window.localStorage, LOCAL_KEY, { dismissedAt: timestamp });
      },

      /**
       * @returns {number | null} timestamp (ms) da última supressão por carrinho/checkout
       */
      getCartSuppressedAt() {
        const value = safeRead(window.localStorage, LOCAL_KEY).cartSuppressedAt;
        return typeof value === 'number' ? value : null;
      },
      /**
       * @param {number} timestamp
       * @returns {void}
       */
      setCartSuppressedAt(timestamp) {
        safeWrite(window.localStorage, LOCAL_KEY, {
          cartSuppressedAt: timestamp,
        });
      },

      /**
       * @returns {number} quantas vezes o balão já piscou nesta sessão (aba)
       */
      getNudgeShowCount() {
        const value = safeRead(
          window.sessionStorage,
          SESSION_KEY
        ).nudgeShowCount;
        return typeof value === 'number' ? value : 0;
      },
      /**
       * @returns {number} contador já incrementado
       */
      incrementNudgeShowCount() {
        const next = this.getNudgeShowCount() + 1;
        safeWrite(window.sessionStorage, SESSION_KEY, {
          nudgeShowCount: next,
        });
        return next;
      },
    };
  })();
}
